{
  "title": "Фреймривер Рилсы",
  "titleReels": "Рилсы",
  "brandPrefix": "Фрейм",
  "brandAccent": "ривер",
  "search": "Поиск пресетов",
  "optional": "необязательно",
  "required": "обязательно",
  "generate": "Сгенерировать",
  "generating": "Генерация…",
  "ready": "Готово",
  "download": "Скачать",
  "share": "Поделиться",
  "linkCopied": "Ссылка скопирована",
  "again": "Заново",
  "repeat": "Повторить",
  "repeatUnavailable": "Пресет больше недоступен",
  "publicReel": {
    "unavailableTitle": "Рилс недоступен",
    "unavailable": "Этот рилс недоступен",
    "openStudio": "Открыть студию",
    "mute": "Выключить звук",
    "unmute": "Включить звук"
  },
  "another": "Выбрать другой пресет",
  "pickAnotherPreset": "Выбрать ещё пресет",
  "by": "автор",
  "cancel": "Отмена",
  "camera": "Снять фото",
  "cameraCapture": "Камера",
  "cameraShutter": "Снять",
  "cameraDenied": "Нет доступа к камере — загрузите файл",
  "cameraStarting": "Включаем камеру…",
  "upload": "Загрузить",
  "recent": "Недавние",
  "trend": "В тренде",
  "new": "Новое",
  "added": "Добавлено",
  "examples": "Что работает лучше всего",
  "topUp": "Пополнить",
  "signIn": "Войти",
  "costUnavailable": "Цена недоступна",
  "notEnough": "Не хватает средств — пополните баланс",
  "askOwnerTopUp": "Попросите владельца компании пополнить баланс",
  "onlineOnlySolo": "Онлайн-оплата доступна только для частного аккаунта. Пополните баланс через биллинг студии.",
  "loginToContinue": "Войдите, чтобы добавить фото и сгенерировать",
  "setupToContinue": "Создайте студию или частный аккаунт, чтобы генерировать и пополнять баланс",
  "payment": {
    "title": "Пополнение",
    "subtitle": "Выберите сумму",
    "topUpHint": "Оплата картой или СБП через ЮKassa. После оплаты вы вернётесь сюда.",
    "topUpHintDesktop": "Оплата картой или СБП откроется в браузере. Это окно дождётся зачисления.",
    "generateHint": "Оплатите недостающую сумму — генерация запустится автоматически после оплаты.",
    "generateHintDesktop": "Оплата откроется в браузере. Это окно дождётся зачисления, затем запустится генерация.",
    "shortageTitle": "Не хватает {{amount}}",
    "payShortage": "Оплатить {{amount}} и сгенерировать",
    "payFull": "Оплатить стоимость генерации · {{amount}}",
    "payMinimum": "Пополнить на {{amount}}",
    "payAmount": "Оплатить {{amount}}",
    "amountLabel": "Сумма, ₽",
    "minHint": "Минимум {{amount}}",
    "invalidAmount": "Укажите корректную сумму",
    "returnHint": "После оплаты вы вернётесь на этот экран",
    "returnHintDesktop": "После оплаты это окно само покажет, что баланс пополнен.",
    "closeWhilePendingTitle": "Закрыть ожидание?",
    "closeWhilePending": "Оплата ещё не подтверждена. Окно можно закрыть — мы сообщим, когда баланс пополнится.",
    "closeWhilePendingConfirm": "Закрыть",
    "waitingTitle": "Подтверждаем оплату",
    "waitingSubtitle": "Это может занять несколько секунд",
    "waitingSubtitleDesktop": "Оплата открыта в браузере",
    "waitingBody": "Ждём подтверждение от платёжной системы…",
    "waitingBodyDesktop": "Это окно дождётся зачисления. Браузер можно закрыть после оплаты.",
    "startingGenerationTitle": "Запускаем генерацию",
    "startingGenerationSubtitle": "Оплата прошла — готовим видео",
    "startingGenerationBody": "Запускаем генерацию…",
    "stillConfirmingTitle": "Ещё подтверждаем оплату",
    "stillConfirmingSubtitle": "Можно закрыть окно — статус обновится при следующем визите",
    "stillConfirmingBody": "Платёж ещё обрабатывается. Вернитесь позже — мы продолжим проверку.",
    "stillConfirmingToast": "Ещё подтверждаем оплату — можно закрыть окно и вернуться позже",
    "generationFailed": "Оплата прошла, но генерацию не удалось запустить. Нажмите «Сгенерировать» — баланс уже пополнен.",
    "unavailable": "Оплата временно недоступна. Попробуйте позже или напишите в поддержку.",
    "successTopUp": "Баланс пополнен",
    "successGenerate": "Оплата прошла — запускаем генерацию",
    "canceled": "Оплата отменена",
    "card": "Банковская карта",
    "sbp": "СБП",
    "soon": "Оплата скоро будет доступна"
  },
  "loginDialog": {
    "heading": "frameriver",
    "subtitle": "Войдите, чтобы сгенерировать видео"
  },
  "signupDialog": {
    "subtitle": "Зарегистрируйтесь, чтобы сгенерировать видео"
  },
  "emptyCatalog": "Пока нет опубликованных пресетов",
  "emptyCatalogHint": "Авторы публикуют пресеты из Stories-проектов.",
  "emptyMine": "Пока нет ваших рилсов",
  "emptyMineHint": "Сгенерируйте видео из каталога — оно появится здесь.",
  "categories": {
    "all": "Все",
    "mine": "Мои",
    "mineCount": "Мои ({{count}})",
    "dance": "Танцы",
    "travel": "Путешествия",
    "fashion": "Мода",
    "food": "Еда",
    "fitness": "Фитнес",
    "other": "Другое"
  },
  "reelStatus": {
    "queued": "В очереди",
    "processing": "Генерация",
    "completed": "Готово",
    "failed": "Ошибка",
    "cancelled": "Отменено"
  },
  "yours": {
    "photo": "Ваши фото",
    "loc": "Ваши локации",
    "prop": "Ваш реквизит"
  },
  "photo": {
    "label": "Ваше фото",
    "hint": "Лицо хорошо видно, ровный свет",
    "short": "обязательно",
    "pick": "Добавьте своё фото"
  },
  "loc": {
    "label": "Локация",
    "hint": "Фото места. Пропустите — возьмём сцену из пресета",
    "short": "необязательно",
    "pick": "Добавьте локацию"
  },
  "prop": {
    "label": "Реквизит",
    "hint": "Предмет, который должен быть в кадре",
    "short": "необязательно",
    "pick": "Добавьте реквизит"
  },
  "examplesPhoto": {
    "0": "Спереди, лицо крупно",
    "1": "Мягкий дневной свет, без очков",
    "2": "Нейтральное выражение"
  },
  "examplesLoc": {
    "0": "Общий план места",
    "1": "Без людей в кадре",
    "2": "Свет как в видео"
  },
  "examplesProp": {
    "0": "Предмет на ровном фоне",
    "1": "Предмет виден целиком",
    "2": "Резко, без смаза"
  },
  "setup": {
    "chooseType": "Выберите тип аккаунта",
    "title": "Продакшн студия",
    "subtitle": "Нужен workspace, чтобы сохранять фото и генерировать видео.",
    "nameLabel": "Название студии",
    "namePlaceholder": "Моя студия",
    "emailLabel": "Email",
    "acceptOffer": "Я принимаю условия оферты",
    "offerRequired": "Примите оферту, чтобы продолжить",
    "continue": "Продолжить",
    "offerLink": "Открыть оферту",
    "or": "или",
    "soloTitle": "Частный аккаунт",
    "soloSubtitle": "Создаю частный аккаунт — без названия студии. Можно генерировать рилсы и пополнять баланс.",
    "soloContinue": "Продолжить как частный"
  },
  "favorite": "В избранное",
  "unfavorite": "Убрать из избранного",
  "costUnknown": "—"
}
